import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
import AuthLayout from 'src/pages/Dashboard/Pages/AuthLayout.vue'
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'

// Page Headers
import DefaultHeader from 'src/pages/Dashboard/DefaultHeader'
import DashboardHeader from 'src/pages/Dashboard/Dashboard/DashboardHeader.vue'

// Dashboard pages
import Dashboard from 'src/pages/Dashboard/Dashboard/Dashboard.vue'
import Login from 'src/pages/Login.vue'

// Pages
import Configuracoes from 'src/pages/Dashboard/configuracoes.vue';
import VencimentoCertificado from 'src/pages/VencimentoCertificado.vue';
import Monitor from 'src/pages/Monitor.vue';
import MonitorFiscal from 'src/pages/MonitorFiscal.vue';
import Usuarios from 'src/pages/Usuarios.vue';
import ContratacaoPlano from 'src/pages/ContratacaoPlano.vue';
import criaToken from 'src/pages/CriaToken.vue';
import criaTokenApp from 'src/pages/CriaTokenApp.vue';
import criaTokenEmissor from 'src/pages/CriaTokenEmissor.vue';
import subirPlanilha from 'src/pages/SubirPlanilha.vue'
import subirPlanilhaClientes from 'src/pages/SubirPlanilhaClientes.vue'
import atualizarPlanilha from 'src/pages/AtualizarPlanilha.vue'
import SubirPlanilhaPizza from 'src/pages/SubirPlanilhaPizza.vue'
import copiarCardapio from 'src/pages/CopiarCardapioPdv.vue'
import Instalacoes from 'src/pages/Instalacoes.vue';
import GrupoEmpresarial from 'src/pages/GrupoEmpresarial.vue';
import FormUsuario from 'src/pages/FormUsuario.vue';
import FormGrupoEmpresarial from 'src/pages/FormGrupoEmpresarial.vue';

/* Marketing */
import NotificationsList from 'src/pages/Notifications/NotificationsList.vue';
import NewNotification from 'src/pages/Notifications/NewNotification/NewNotification.vue';
import TagInsertion from 'src/pages/Notifications/Tags/TagInsertion.vue';
import TagsList from 'src/pages/Notifications/Tags/TagsList.vue';
import Campaigns from 'src/pages/Marketing/Campaigns.vue';
import NewCampaign from 'src/pages/Marketing/Campaigns/NewCampaign.vue';
import SuggestionsPictures from 'src/pages/SuggestionsPictures.vue';
import MenuAi from "@/pages/MenuAi.vue";
import AddIcon from "@/pages/AddIcon.vue";
import NcmSuggestion from "@/pages/NcmSuggestion.vue";



const routes = [
  {
    path: '/',
    redirect: '/login',
    name: 'Home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard',
    children: [
      {
        path: '/monitor',
        name: 'monitor',
        components: {default: Monitor, header: DefaultHeader},
      },
      {
        path: '/criaTokenDesk',
        name: 'criaTokenDesk',
        components: {default: criaToken, header: DefaultHeader},
      },
      {
        path: '/criaTokenApp',
        name: 'criaTokenApp',
        components: {default: criaTokenApp, header: DefaultHeader},
      },
      {
        path: '/criaTokenEmissor',
        name: 'criaTokenEmissor',
        components: {default: criaTokenEmissor, header: DefaultHeader},
      },
      {
        path: '/subirPlanilha',
        name: 'subirPlanilha',
        components: {default: subirPlanilha, header: DefaultHeader},
      },
      {
        path: '/subirPlanilhaClientes',
        name: 'subirPlanilhaClientes',
        components: {default: subirPlanilhaClientes, header: DefaultHeader},
      },
      {
        path: '/atualizarPlanilha',
        name: 'atualizarPlanilha',
        components: {default: atualizarPlanilha, header: DefaultHeader},
      },
      {
        path: '/planilha-pizza',
        name: 'SubirPlanilhaPizza',
        components: {default: SubirPlanilhaPizza, header: DefaultHeader},
      },
      {
        path: '/copiarCardapio',
        name: 'copiarCardapio',
        components: {default: copiarCardapio, header: DefaultHeader},
      },
      {
        path: '/usuarios',
        name: 'usuários',
        components: {default: Usuarios, header: DefaultHeader},
      },
      {
        path: '/usuarios/novo',
        name: 'Novo usuário',
        components: {default: FormUsuario, header: DefaultHeader},
      },
      {
        path: '/usuarios/editar/:id',
        name: 'Editar usuário',
        components: {default: FormUsuario, header: DefaultHeader},
      },

      {
        path: '/grupos',
        name: 'Grupos Empresariais',
        components: {default: GrupoEmpresarial, header: DefaultHeader},
      },

      {
        path: '/instalacoes',
        name: 'Instalações',
        components: {default: Instalacoes, header: DefaultHeader},
      },

      {
        path: '/grupos/novo',
        name: 'Novo Grupo Empresarial',
        components: {default: FormGrupoEmpresarial, header: DefaultHeader},
      },
      {
        path: '/grupos/editar/:id',
        name: 'Editar Grupo Empresarial',
        components: {default: FormGrupoEmpresarial, header: DefaultHeader},
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        components: {default: Dashboard, header: DashboardHeader},
      },
      {
        path: 'configuracoes',
        name: 'Configuracoes',
        components: {default: Configuracoes, header: DefaultHeader},
      },
      {
        path: '/vencimentoCertificado',
        name: 'Certificados Vencendo',
        components:  {default:VencimentoCertificado, header: DefaultHeader},
      },
      {
        path: '/monitor-fiscal',
        name: "Monitor Fiscal",
        components: {default: MonitorFiscal, header: DefaultHeader},
      },
      {
        path: '/campaigns',
        name: "Campanhas",
        components: {default: Campaigns, header: DefaultHeader},
      },
      {
        path: '/notifications-list',
        name: "Campanhas",
        components: {default: NotificationsList, header: DefaultHeader},
      },
      {
        path: '/notifications-list-new/create',
        name: "Nova Campanha",
        components: {default: NewNotification, header: DefaultHeader},
      },
      {
        path: '/notifications-list-new/edit/:id',
        name: "Nova Campanha",
        components: {default: NewNotification, header: DefaultHeader},
      },
      {
        path: '/tag-insertion',
        name: "Inserção de Tags",
        components: {default: TagInsertion, header: DefaultHeader},
      },
      {
        path: '/tags-list',
        name: "Lista de Tags",
        components: {default: TagsList, header: DefaultHeader},
      },
      {
        path: '/campaigns/new',
        name: "Nova Campanha",
        components: {default: NewCampaign, header: DefaultHeader},
      },
      {
        path: '/suggestions',
        name: "Sugestão de Imagens",
        components: {default: SuggestionsPictures, header: DefaultHeader},
      },
      {
        path: '/contratacao-planos',
        name: "Contratação de Planos",
        components: {default: ContratacaoPlano, header: DefaultHeader},
      },
      {
        path: '/menu-ai',
        name: "Cadastro de Menu com IA",
        components: {default: MenuAi, header: DefaultHeader},
      },
      {
        path: '/add-icon',
        name: "Cadastro de Icones para a Geração com IA",
        components: {default: AddIcon, header: DefaultHeader},
      },
      {
        path: '/ncm-suggestion',
        name: 'NcmSuggestion',
        components: { default: NcmSuggestion, header: DefaultHeader },
      },
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
